const getters = {
  comments: state => state.comments,
  commentsAmount: state => {
    if (!state.totalComments) {
      return 'No hay comentarios';
    }
    if (state.totalComments === 1) {
      return `${state.totalComments} comentario`;
    }
    return `${state.totalComments} comentarios`;
  },
  featuredComment: state => state.featuredComment,
  partnerComments: state => state.partnerComments,
  pages: state => state.pages,
  currentPage: state => state.currentPage,
  totalComments: state => state.totalComments,
  // Para responder usuarios
  replyingUserNick: state => state.replyingUserNick,
  isUserMuted: state => userId => state.mutedUsers.includes(userId),
  commentUserLikesList: state => commentId => state.commentUserLikes[commentId] ?? [],
  isLikedComment: state => commentId => state.userLikedCommentIds.includes(commentId),
  // se usa para comprobar si el nick del usuario de un comentario es igual
  // al nick del usuario actualmente loggeado
  isOwnComment: state => userNick => state.nick === userNick,
  userProfile: (state, getters) => userProfileUrl => getters.isLogged ? userProfileUrl : null
};

export default getters;